<template>
  <div>
    <div class="bg-white rounded-lg text-center color-bold-vmain  mb-11">
        <div class="mt-3 text-center">
            <div class=" font-bold m-auto text-lg">
                Bạn có thể nhận tư vấn gói vay nhanh qua đăng ký xe máy/ ôtô
            </div>
            <img class="m-auto mt-3" src="@/assets/default_main/tima2a.png">
        </div>
        <div class="mt-3">
            <div class=" text-left rounded-md text-base" style="font-family: Arial;">
                <!-- Chọn hình thức vay: -->
            
                <ul>
                    <li v-for="item in List" :key="item.type">
                        <div class="grid grid-cols-9">
                            <div ><img style="width: 16px;" src="@/assets/default_main/v.png"></div>
                            <div class="col-span-8">{{ item.type_name }}</div>
                        </div>
                         
                    </li>
                </ul>
            </div>
            
            <!-- <select v-model="type" class="w-full shadow-input focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent rounded-sm p-1 mt-1" name="cars" id="cars">
                <option v-for="item in option" :key="item.type" :value="item.type">{{item.type_name}}</option>
             
            </select> -->
        </div>

        <div class="mt-4 text-center">
            <div class="grid grid-cols-3 gap-4">
                <div class="border-gray-200 border-2 p-1 rounded-lg">
                    <button @click="toHomePage" class="font-bold" > Bỏ qua</button>
                </div>
                <div class="col-span-2">
                    <button @click="register" class="bg-color-vmain text-white font-bold text-center w-full p-2 rounded-md shadow-lg"> Nhận tư vấn ngay </button>
                </div>
            </div>
            <!-- <button @click="register" class="bg-main text-white font-bold rounded-md m-auto" style="box-shadow: 4px 3px 5px rgba(100, 21, 95, 0.34); height: 31px; width: 261px;"> Nhận tư vấn ngay </button>

            <div @click="toHomePage" class="mt-3 color-main2 font-bold">
                Bỏ qua
            </div> -->
        </div>
    </div>
  </div>
</template>

<script>
import { getPhone} from '@/utils/auth'
import { registerTima } from '@/api/otp'
import { toDMY,toYMD,toYMDHMS } from "@/filters/index"

export default {
    data() {
        return {
            option: [
                {
                    type: 1,
                    type_name: 'Vay thế chấp với cà vẹt xe máy'
                },
                {
                    type: 2,
                    type_name: 'Vay thế chấp với xe máy'
                },
                {
                    type: 3,
                    type_name: 'Vay thế chấp với cà vẹt ô tô'
                },
                {
                    type: 4,
                    type_name: 'Vay thế chấp với ô tô'
                },
            ],
            List: [
                {
                    type: 1,
                    type_name: 'Không giữ xe, Khách hàng vẫn có xe để đi lại bình thường'
                },
                {
                    type: 2,
                    type_name: 'Thủ tục nhanh gọn, giải ngân chỉ trong 2 giờ'
                },
                {
                    type: 3,
                    type_name: 'Lãi suất cạnh tranh'
                },
            ],
            type: 1,
            // type_name: 'Vay thế chấp với cà vẹt xe máy'
        }
    },
    methods: {
        toHomePage (){
            this.$bvModal.hide('modal-tima')
            //this.$router.push('/')
            this.$bvModal._root.$children[0].modal = {
                title: 'Cảm ơn bạn đã để lại thông tin',
                content: 'Đối tác giải ngân sẽ liên hệ hỗ trợ bạn trong thời gian sớm nhất. Gọi số 1900633337 nếu bạn chưa được liên hệ',
                btnHome: true
            }
            this.$bvModal.show('modal-vmain-notify')
        },
        register(){
            registerTima(this.option[this.type-1]).then(res => {
                this.$bvModal.hide('modal-tima')

                if(res.status == 200 || res.status ==0){
                    this.$bvModal._root.$children[0].modal = {
                        title: 'Cảm ơn bạn đã để lại thông tin',
                        content: 'Đối tác giải ngân sẽ liên hệ hỗ trợ bạn trong thời gian sớm nhất. Gọi số 1900633337 nếu bạn chưa được liên hệ',
                        btnHome: true
                    }
                    this.$bvModal.show('modal-vmain-notify')
                    // this.$bvToast.toast('Đăng ký vay thành công', {
                    //         title: 'Thành công',
                    //         variant: 'success',
                    //         solid: true
                    //     })
                }
            })
        }

    },
}
</script>

<style>

</style>